// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"143":"00aa98c5","464":"c87e1f23"}[chunkId] + ".chunk.css";
};